export const ApplicationOptions = {
  SMS: 1,
  CONSENTS: 2,
  VIN: 3
}

export default ApplicationOptions
